exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{position:relative;height:100%;font-size:12px}body:after{background-image:url(" + require("./../imgs/public_relation_bg_img_a.jpg") + ")}a:active,a:hover,a:link,a:visited{color:#d3a571!important}.info-style{padding:20px 0 10px}@media (min-width:768px){.info-style{padding:0 0 0 30px}}.list-style{margin:0 20px 80px;padding:0 30px 20px;background-color:#fff}@media (min-width:768px){.list-style{margin:0 20px 80px;padding:0 30px 30px;background-color:#fff}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-49ca4170","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/public_relation.vue
// module id = 69
// module chunks = 9